import React, {Component} from 'react';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
class NotFound extends Component {
    render(){
        return(
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <div className="clearfix">
                                <h1 className="float-left display-3 mr-4">404</h1>
                                <h4 className="pt-3">Página no encontrada</h4>
                                <p className="text-muted float-left">Lo sentimos, página que buscas no existe actualmente.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default NotFound


// WEBPACK FOOTER //
// ./resources/assets/js/components/errors/404.jsx